type ThemeNames = typeof docuSignThemeName
export type DocuSignThemeName = ThemeNames[keyof ThemeNames]

export const docuSignThemeName = {
  olive: 'Olive',
  ink: 'Ink',
} as const
